module.exports = __webpack_public_path__ + "img/logo-w.c6a67e39.png";